
import React, { useState, useEffect } from 'react';
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { BusinessAvatar } from './BusinessAvatar';

interface BusinessLogoProps {
  logoUrl?: string;
  businessName: string;
  size?: 'compact' | 'full';
  className?: string;
}

export const BusinessLogo: React.FC<BusinessLogoProps> = ({ 
  logoUrl, 
  businessName,
  size = 'full',
  className = ''
}) => {
  const [isLandscape, setIsLandscape] = useState(false);
  
  useEffect(() => {
    if (logoUrl) {
      const img = new Image();
      img.onload = () => {
        setIsLandscape(img.width > img.height);
      };
      img.src = logoUrl;
    }
  }, [logoUrl]);

  if (!logoUrl) {
    return (
      <BusinessAvatar 
        name={businessName} 
        size={size === 'compact' ? 'sm' : 'md'} 
        className={className}
      />
    );
  }

  // Use a consistent square container for compact size, wider for full size
  const containerSize = size === 'compact' ? "h-8 w-8" : "h-8 w-16";

  return (
    <div className={`${containerSize} relative rounded-md overflow-hidden ${className}`}>
      <AspectRatio ratio={size === 'compact' ? 1 : 16 / 9}>
        <img 
          src={logoUrl} 
          alt={businessName} 
          className="w-full h-full object-contain object-left" 
        />
      </AspectRatio>
    </div>
  );
};
